import { resolveSpacingArg } from './computeSpacingArg';

import { SpacingArg, StyleObj } from '../types';

export type PaddinSpacingArgs =
  | [SpacingArg]
  | [SpacingArg, SpacingArg]
  | [SpacingArg, SpacingArg, SpacingArg]
  | [SpacingArg, SpacingArg, SpacingArg, SpacingArg];

export type PaddingMixin = (...ars: PaddinSpacingArgs) => StyleObj;

export function makePaddingMixin(spacingUnit: number): PaddingMixin {
  return (...args: PaddinSpacingArgs) => {
    const values = args.map((arg) => {
      const value = resolveSpacingArg(arg, spacingUnit);
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      return numValue;
    });

    if (values.length === 1) {
      return {
        paddingTop: values[0],
        paddingRight: values[0],
        paddingBottom: values[0],
        paddingLeft: values[0],
      };
    }

    if (values.length === 2) {
      return {
        paddingTop: values[0],
        paddingRight: values[1],
        paddingBottom: values[0],
        paddingLeft: values[1],
      };
    }

    if (values.length === 3) {
      return {
        paddingTop: values[0],
        paddingRight: values[1],
        paddingBottom: values[2],
        paddingLeft: values[1],
      };
    }

    if (values.length === 4) {
      return {
        paddingTop: values[0],
        paddingRight: values[1],
        paddingBottom: values[2],
        paddingLeft: values[3],
      };
    }

    return {};
  };
}
